import styled from 'styled-components'
import { ReactElement } from 'react'
import { SortSelect } from './SortSelect'
import { I18n } from 'common'

export interface Option {
  value: string
  label: string
}

interface ISelectCustomField {
  value: string
  options: Option[]
  // TODO: use string instead of unknown here.
  onChange?: (value: unknown) => void
  onSelect?: (value: unknown) => void
  title: string
  disabled?: boolean
  cursorType: string
  width?: string
}

const SelectCustomField = ({
  value,
  options,
  onChange = () => undefined,
  onSelect,
  title,
  disabled,
  cursorType,
}: ISelectCustomField): ReactElement => {
  return (
    <SelectWrapper>
      <SelectLabel>
        <I18n name={title || ''} />
      </SelectLabel>
      <SortSelect
        onChange={(newValue) => {
          if (onSelect) {
            onSelect(newValue)
          }
          if (newValue !== value) {
            if (onChange) {
              onChange(newValue)
            }
          }
        }}
        value={value}
        options={options}
        disabled={disabled}
        cursorType={cursorType}
        width="260px"
      />
    </SelectWrapper>
  )
}

export default SelectCustomField

const SelectWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px;
`
const SelectLabel = styled.span`
  font-family: Roboto, serif;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 24px;
  color: #050505;
  margin-right: 5px;
  width: 100px;
`
